import { NgModule } from '@angular/core';

import { IdComponent } from './component';

@NgModule({
  declarations: [IdComponent],
  exports : [IdComponent]
})
export class LKId {}
